import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Footer } from 'src/shared';

const MRIContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%);
  color: white;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(30, 58, 138, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.25);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin: 0;
  text-shadow: 0 4px 8px rgba(30, 58, 138, 0.4);
`;

const Content = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const MRICard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: 40px;
  max-width: 800px;
  text-align: center;
`;

const MRIIcon = styled.div`
  font-size: 5rem;
  margin-bottom: 20px;
`;

const MRITitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #60a5fa;
`;

const MRIDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
`;

const FeatureList = styled.ul`
  text-align: left;
  font-size: 1rem;
  line-height: 1.8;
  opacity: 0.9;
`;

const MRI: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MRIContainer>
      <Header>
        <BackButton onClick={() => navigate('/medical_imaging')}>
          ← Back to Medical Imaging
        </BackButton>
        <Title>MRI Imaging</Title>
        <div style={{ width: '120px' }}></div>
      </Header>

      <Content>
        <MRICard>
          <MRIIcon>🧠</MRIIcon>
          <MRITitle>Magnetic Resonance Imaging</MRITitle>
          <MRIDescription>
            Advanced MRI technology for detailed brain and body imaging with high-resolution 
            cross-sectional views and superior soft tissue contrast.
          </MRIDescription>
          
          <FeatureList>
            <li><strong>Brain Imaging:</strong> Detailed structural and functional brain mapping</li>
            <li><strong>Body Scans:</strong> Comprehensive internal organ examination</li>
            <li><strong>High Resolution:</strong> Sub-millimeter precision imaging</li>
            <li><strong>Multi-Contrast:</strong> T1, T2, FLAIR, and diffusion-weighted imaging</li>
            <li><strong>3D Reconstruction:</strong> Volumetric analysis and visualization</li>
            <li><strong>AI Analysis:</strong> Automated lesion detection and quantification</li>
          </FeatureList>
        </MRICard>
      </Content>

      <Footer />
    </MRIContainer>
  );
};

export default MRI;
